import React, {
  useMemo,
} from "react";
import Table from "../UI/Table";
import { PageWrapper } from "../UI/Grid";
import { Body } from "../UI/Text";
import styled from "styled-components";

const PageWrapperStyled = styled(PageWrapper)`
  min-width: 900px;
`;

const ShippingInfo = (props) => {
  const columns = useMemo(
    () => [
      
      {
        id: "invoiceNum",
        data: (row) => <Body center>{row?.invoiceNum}</Body>,
        header: "Invoice #",
        size: { md: 4, sm: 2, xs: 2 },
        sort: false,
      },
      {
        id: "trackingNumber",
        data: (row) => <Body center>{row?.trackingNumber}</Body>,
        header: "Tracking #",
        size: { md: 2, sm: 2, xs: 2 },
        sort: false,
      }, 
      {
        id: "item",
        data: (row) => <Body center>{row?.item}</Body>,
        header: "Part #",
        size: { md: 2, sm: 2, xs: 2 },
        sort: false,
      },  
      {
        id: "invoiceQty",
        data: (row) => <Body center>{row?.invoiceQty}</Body>,
        header: "Invoice Qty",
        size: { md: 2, sm: 2, xs: 2 },
        sort: false,
      },  
      {
        id: "shippedQty",
        data: (row) => <Body center>{row?.shippedQty}</Body>,
        header: "Shipped Qty",
        size: { md: 2, sm: 2, xs: 2 },
        sort: false,
      },                
    ],
  
    []
  );  
 
  return (
    <>      
      <PageWrapperStyled>       
        <Table
          title={"Shipping Info"}                                     
          //isLoading={isLoading}
          //subtitle={"Line Details"}
          columns={columns}
          data={props?.lineDetails}
          dropdown={false}
          hideToggle
          totalCount={props?.lineDetails?.length || 0}  
          hideRefetch
          hideSearch  
          hidePagination
          hideProperties
          hideCreate                             
             
        />
      </PageWrapperStyled>
    </>
  );
};

export default ShippingInfo;
